import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const topMargin: AdminBlockTypeAttribute = {
  label: 'Add top margin',
  key: 'topMargin',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default topMargin;
